

app.controller('CIF4-CTRL',
    ['$scope', '$rootScope', '$uibModal', '$http', '$window', '$timeout', '$q', '$filter', 'KTPCamService', 'SELFIECamService', 'deviceDetector',
    function ($scope, $rootScope, $uibModal, $http, $window, $timeout, $q, $filter, KTPCamService, SELFIECamService, deviceDetector) {

        $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];
        $scope.agree1 = false;
        $scope.agree2 = false;
        $scope.agree3 = false;
        $scope.device = deviceDetector;
        $scope.isMobile = $scope.device.isMobile();

        $scope.filenameKTP = "";
        $scope.fileKTP = "";
        $scope.fileKTPext = "";
        $scope.KTPFile = [];

        $scope.filenameFotoDiri = "";
        $scope.fileFotoDiri = "";
        $scope.fileFotoDiriext = "";
        $scope.fotodiriFile = [];

        $scope.append = '';


        $scope.filenameTandaTangan = "";
        $scope.fileTandaTangan = "";
        $scope.fileTandaTanganext = "";
        $scope.tandatanganFile = [];

        $scope.filenameNPWP = "";
        $scope.fileNPWP = "";
        $scope.fileNPWPext = "";
        $scope.NPWPFile = [];

        $scope.filenameTabungan = "";
        $scope.fileTabungan = "";
        $scope.fileTabunganext = "";
        $scope.tabunganFile = [];

        $scope.finishSignature = false;

        $scope.openCamera = function (tipe) {
            let message = tipe;
            let url = 'ModalCamera.html';
            let ctrl = 'CameraController';


            //if ($scope.device.isMobile()) {
            //    $scope.append = 'data:image/png;base64,';
            //}

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: url,
                controller: ctrl,
                size: 'md',
                resolve: {
                    items: function () {
                        return message;
                    }
                }
            });
            modalInstance.result.then(function (resolvedResponse) {
                //console.log('ktp',resolvedResponse);
                if (resolvedResponse) {
                    if (tipe == "KTP")
                        $scope.ktpPhoto = resolvedResponse;
                    else if (tipe == "NPWP")
                        $scope.npwpPhoto = resolvedResponse;
                    else if (tipe == "PASSBOOK")
                        $scope.tabunganPhoto = resolvedResponse;
                    else if (tipe == "SELFIE")
                        $scope.selfiePhoto = resolvedResponse;
                    //else
                    //    $scope.ttdPhoto = resolvedResponse;
                }
            }, function () { });
        };



        $scope.remove = function (tipe) {
            if (tipe == "KTP")
                $scope.ktpPhoto = '';
            else if (tipe == "NPWP")
                $scope.npwpPhoto = '';
            else if (tipe == "PASSBOOK")
                $scope.tabunganPhoto = '';
            else if (tipe == "SELFIE")
                $scope.selfiePhoto = '';
        };



        $scope.selectKTP = function (files) {
            $scope.KTPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileKTP = btoa(e.target.result.toString());
                }
            };
            console.log('gambar', $scope.KTPFile);
            reader.readAsBinaryString(files[0]);
            $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileKTPext = '';
                $scope.KTPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameKTP = files[0].name;
        };

        $scope.selectFotoDiri = function (files) {
            $scope.fotodiriFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileFotoDiri = btoa(e.target.result.toString());
                }
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileFotoDiriext = files[0].name.substr(files[0].name.lastIndexOf('.'));
            if ($scope.allowedExt.indexOf($scope.fileFotoDiriext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileFotoDiriext = '';
                $scope.fotodiriFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameFotoDiri = files[0].name;
        };

        $scope.selectTandaTangan = function (files) {
            $scope.tandatanganFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileTandaTangan = btoa(e.target.result.toString());
                }
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileTandaTanganext = files[0].name.substr(files[0].name.lastIndexOf('.'));
            if ($scope.allowedExt.indexOf($scope.fileTandaTanganext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileTandaTanganext = '';
                $scope.tandatanganFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameTandaTangan = files[0].name;
        };

        $scope.selectNPWP = function (files) {
            $scope.NPWPFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileNPWP = btoa(e.target.result.toString());
                }
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileNPWPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileNPWPext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileNPWPext = '';
                $scope.NPWPFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameNPWP = files[0].name;
        };

        $scope.selectTabungan = function (files) {
            $scope.TabunganFile = files;
            let allowed = true;
            var reader = new FileReader();

            reader.onload = function (e) {
                if (allowed) {
                    $scope.fileTabungan = btoa(e.target.result.toString());
                }
            };

            reader.readAsBinaryString(files[0]);
            $scope.fileTabunganext = files[0].name.substr(files[0].name.lastIndexOf('.'));

            if ($scope.allowedExt.indexOf($scope.fileTabunganext.toLowerCase()) < 0) {
                allowed = false;
                $scope.fileTabunganext = '';
                $scope.TabunganFile = '';
                alert("Extensi yang dibolehkan : " + $scope.allowedExt);
            }
            else
                $scope.filenameTabungan = files[0].name;
        };

        $scope.clickRemoveKTP = function (file, event, key) {
            event.preventDefault();
            $scope.fileKTP = "";
            $scope.filenameKTP = "";
            $scope.fileKTPext = "x";
            $scope.KTPFile.splice(key, 1);
            $scope.KTPFile = [];
            return null;
        };

        $scope.clickRemoveFotoDiri = function (file, event, key) {
            event.preventDefault();
            $scope.fileFotoDiri = "";
            $scope.filenameFotoDiri = "";
            $scope.fileFotoDiriext = "x";
            $scope.fotodiriFile.splice(key, 1);
            $scope.fotodiriFile = [];

            return null;
        };

        $scope.clickRemoveTandaTangan = function (file, event, key) {
            event.preventDefault();
            $scope.fileTandaTangan = "";
            $scope.filenameTandaTangan = "";
            $scope.fileTandaTanganext = "x";
            $scope.tandatanganFile.splice(key, 1);
            $scope.tandatanganFile = [];
            return null;
        };

        $scope.clickRemoveNPWP = function (file, event, key) {
            event.preventDefault();
            $scope.fileNPWP = "";
            $scope.filenameNPWP = "";
            $scope.fileNPWPext = "x";
            $scope.NPWPFile.splice(key, 1);
            $scope.NPWPFile = [];
            return null;
        };

        $scope.clickRemoveTabungan = function (file, event, key) {
            event.preventDefault();
            $scope.fileTabungan = "";
            $scope.filenameTabungan = "";
            $scope.fileTabunganext = "x";
            $scope.TabunganFile.splice(key, 1);
            $scope.TabunganFile = [];
            return null;
        };


        $scope.resetSign = function () {
            $rootScope.AlertYesNo('question', 'Konfirmasi', "Hapus Data Tanda Tangan?")
           .then((result) => {
               if (result.value) {
                   $scope.finishSignature = false;
                   $scope.filenameTandaTangan = '';
                   $scope.append = '';
                   $scope.clear();
               }
           });
        };

        $scope.completeSign = function () {
            $scope.signature = $scope.accept();
            $scope.append = '';
            if ($scope.signature.dataUrl && !$scope.signature.isEmpty) {
                $scope.finishSignature = true;
                $scope.CIFInvestor.TandaTanganFile = $scope.signature.dataUrl.substr($scope.signature.dataUrl.lastIndexOf(',') + 1);
                $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                $scope.append = 'data:image/png;base64,';
            }
            else
                $scope.filenameTandaTangan = '';
        };



        $scope.validateAgreement = function () {

            if ($scope.CIFInvestor.QuestionRDN == 1) {

                if (!$scope.agree1 || !$scope.agree2) {
                    $scope.disclaimerBank = false;
                    swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA, KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk', 'error');
                }

                if (!$scope.agree1 && $scope.agree2) {
                    $scope.disclaimerBank = false;
                    swal('Error', 'Mohon klik PERNYATAAN NASABAH RDN BCA', 'error');
                }

                if ($scope.agree1 && !$scope.agree2) {
                    $scope.disclaimerBank = false;
                    swal('Error', 'Mohon klik KETENTUAN-KETENTUAN TAPRES PT BANK CENTRAL ASIA Tbk', 'error');
                }

                if ($scope.agree1 && $scope.agree2 && $scope.agree3 && $scope.agree7 && $scope.agree8) {
                    $scope.disclaimerBank = true;
                }
            }
        }

        $scope.validateAgreementRDNBCA = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree1) {
                    $scope.disclaimerRDNBCA = false;
                    $scope.showAgreement(1);
                }
            }
        }

        $scope.validateAgreementTAPRESBCA = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree2) {
                    $scope.disclaimerTAPRESBCA = false;
                    $scope.showAgreement(2);
                }
            }
        }

        $scope.validateAgreementPTMKES = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree3) {
                    $scope.disclaimerPTMKES = false;
                    $scope.showAgreement(3);
                }
            }
        }

        $scope.validateAgreementDEKLARASI = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree4) {
                    $scope.disclaimerDEKLARASI = false;
                    $scope.showAgreement(4);
                }
            }
        }

        $scope.validateAgreementKAF = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree5) {
                    $scope.disclaimerKAF = false;
                    $scope.showAgreement(5);
                }
            }
        }

        $scope.validateAgreementBJB = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree6) {
                    $scope.disclaimerBJB = false;
                    $scope.showAgreement(6);
                }
            }
        }

        $scope.validateAgreementRIPLAYBCA = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree7) {
                    $scope.disclaimerRIPLAYBCA = false;
                    $scope.showAgreement(7);
                }
            }
        }

        $scope.validateAgreementESTATEMENTBCA = function () {
            if ($scope.CIFInvestor.QuestionRDN == 1) {
                if (!$scope.agree8) {
                    $scope.disclaimerESTATEMENTBCA = false;
                    $scope.showAgreement(8);
                }
            }
        }


        $scope.modalMessage = {
            message: '',
            param: {}
        };




        $scope.openModal = function () {
            var tempUrl = 'myModalContent.html';
            if ($scope.buttonText == "Save")
                tempUrl = 'myModalContentSementara.html';
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: tempUrl,
                controller: 'ModalInstanceCIFCtrl',
                size: 'md',
                resolve: {
                    items: function () {
                        return $scope.modalMessage;
                    }
                }
            });
        };

        $scope.showAgreement = function (number) {
            let htmlName = 'BCAagereement' + number + '.html';
            var modalInstance = $uibModal
            .open({
                animation: true,
                templateUrl: htmlName,
                controller: 'BCAAgreementCtrl',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    agreementNumber: function () {
                        return number;
                    }
                }
            });
            modalInstance.result.then(function (response, agree) {
                if (response == 'accept') {
                    if (number == 1) {
                        $scope.agree1 = true;
                        $scope.disclaimerRDNBCA = true;
                    }

                    if (number == 2) {
                        $scope.agree2 = true;
                        $scope.disclaimerTAPRESBCA = true;
                    }

                    if (number == 3) {
                        $scope.agree3 = true;
                        $scope.disclaimerPTMKES = true;
                    }

                    if (number == 4) {
                        $scope.agree4 = true;
                        $scope.disclaimerDEKLARASI = true;
                    }

                    if (number == 5) {
                        $scope.agree5 = true;
                        $scope.disclaimerKAF = true;
                    }

                    if (number == 6) {
                        $scope.agree6 = true;
                        $scope.disclaimerBJB = true;
                    }

                    if (number == 7) {
                        $scope.agree7 = true;
                        $scope.disclaimerRIPLAYBCA = true;
                    }

                    if (number == 8) {
                        $scope.agree8 = true;
                        $scope.disclaimerESTATEMENTBCA = true;
                    }

                    if ($scope.disclaimerRDNBCA == true && $scope.disclaimerTAPRESBCA == true && $scope.disclaimerRIPLAYBCA == true && $scope.disclaimerESTATEMENTBCA == true) {
                        $scope.disclaimerBank = true;
                    }

                }
            }, function () { });
        };

        var allPromise = $q.all([
            $http({
                method: 'POST',
                url: 'service/client.svc/retrieveSession',
            }).then(function (data) {
                if (!data.data.d) {
                    $http({
                        method: 'GET',
                        url: 'service/client.svc/SignOut',
                    }).then(function (data) {
                        if (data.data.d == true) {
                            $window.location.href = "#/login";
                            $window.location.reload();
                        }
                    }, function (error) { })
                }
                else
                    $scope.currentUser = data.data.d;
            }, function (error) { }),

             $http({
                 method: 'GET',
                 url: 'service/client.svc/GetPED',
             }).then(function (data) {

                 if (data.data.d != null) {
                     $scope.broker = data.data.d;
                     console.log(" Name", $scope.broker.BROKERName);
                 }
             }, function (error) { }),
        ]);



        allPromise.then(function () {
            $http({
                method: 'GET',
                url: 'service/client.svc/getCIF',
            }).then(function (data) {
                if (data.data.d != null) {
                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 4;
                    $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                    $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                    $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                    $scope.filenameNPWP = $scope.CIFInvestor.NPWPFile;
                    $scope.filenameTabungan = $scope.CIFInvestor.BukuTabunganFile;
                    $scope.npwpPhoto = $scope.CIFInvestor.NPWPFile;
                    console.log(" npwp ", $scope.npwpPhoto);
                    if ($scope.CIFInvestor.KTPFile) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.CIFInvestor.KTPFile,
                            responseType: 'blob',

                        }).then(function (responseKTP) {
                            $scope.append = '';
                            //let readerKTP = new FileReader();
                            //readerKTP.readAsDataURL(responseKTP.data);
                            //readerKTP.onloadend = function () {
                            //    $scope.filenameKTP = readerKTP.result;
                            //}
                            //$scope.KTPFile = [];
                            //$scope.KTPFile.push(responseKTP.data);
                            var readerKTP = new FileReader();
                            readerKTP.readAsDataURL(responseKTP.data);
                            readerKTP.onloadend = function () {
                                $scope.ktpPhoto = readerKTP.result;
                            }
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    };



                    if ($scope.CIFInvestor.SelfieFile) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.CIFInvestor.SelfieFile,
                            responseType: 'blob',

                        }).then(function (responseSelfie) {
                            let readerSelfie = new FileReader();
                            readerSelfie.readAsDataURL(responseSelfie.data);
                            readerSelfie.onloadend = function () {
                                $scope.selfiePhoto = readerSelfie.result;
                            }
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    };


                    if ($scope.CIFInvestor.TandaTanganFile) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.CIFInvestor.TandaTanganFile,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.append = '';
                            let reader = new FileReader();
                            reader.readAsDataURL(response.data);
                            reader.onloadend = function () {
                                $scope.filenameTandaTangan = reader.result;
                            }
                            //$scope.tandatanganFile = [];
                            //$scope.tandatanganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    };

                    if ($scope.filenameNPWP) {

                        if (!$scope.filenameNPWP.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameNPWP,
                                responseType: 'blob',

                            }).then(function (responseNPWP) {
                                //$scope.NPWPFile = [];
                                //$scope.NPWPFile.push(response.data);
                                let readerNPWP = new FileReader();
                                readerNPWP.readAsDataURL(responseNPWP.data);
                                readerNPWP.onloadend = function () {
                                    $scope.npwpPhoto = readerNPWP.result;
                                }
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };

                    if ($scope.filenameTabungan) {

                        if (!$scope.filenameTabungan.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameTabungan,
                                responseType: 'blob',

                            }).then(function (responseTabungan) {
                                //$scope.tabunganFile = [];
                                //$scope.tabunganFile.push(response.data);
                                let readerTabungan = new FileReader();
                                readerTabungan.readAsDataURL(responseTabungan.data);
                                readerTabungan.onloadend = function () {
                                    $scope.tabunganPhoto = readerTabungan.result;
                                }
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };

                    if ($scope.CIFInvestor.IsFinished == 1) {
                        $scope.disclaimerBank = true;
                        $scope.disclaimerRDNBCA = true;
                        $scope.disclaimerTAPRESBCA = true;
                        $scope.disclaimerPTMKES = true;
                        $scope.disclaimerDEKLARASI = true;
                        $scope.disclaimerKAF = true;
                        $scope.disclaimerBJB = true;
                        $scope.disclaimerRIPLAYBCA = true;
                        $scope.disclaimerESTATEMENTBCA = true;
                    }

                } // END IF data.data.d
            }, function (error) { });
        });

        $scope.prepareData = function () {
        }

        $scope.submitfile = function () {
            $scope.CIFInvestor.IsFinished = 0;
            $scope.CIFInvestor.Stage = 4;

            if (!$scope.broker.OAO) {
                //$scope.CIFInvestor.KTPFile = $scope.fileKTP;
                //$scope.CIFInvestor.SelfieFile = $scope.fileFotoDiri;
                $scope.CIFInvestor.IsFinished = 1;

                if ($scope.ktpPhoto)
                    $scope.CIFInvestor.KTPFile = $scope.ktpPhoto.replace("data:image/jpeg;base64,", "");

                if ($scope.npwpPhoto)
                    $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

                if ($scope.tabunganPhoto)
                    $scope.CIFInvestor.BukuTabunganFile = $scope.tabunganPhoto.replace("data:image/jpeg;base64,", "");

                if ($scope.selfiePhoto)
                    $scope.CIFInvestor.SelfieFile = $scope.selfiePhoto.replace("data:image/jpeg;base64,", "");

            } else {

                if ($scope.npwpPhoto)
                    $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

                if ($scope.tabunganPhoto)
                    $scope.CIFInvestor.BukuTabunganFile = $scope.tabunganPhoto.replace("data:image/jpeg;base64,", "");
            }

            console.log("NPWP2 ", $scope.CIFInvestor.NPWPFile);
            console.log("TTD2 ", $scope.CIFInvestor.TandaTanganFile);

            $scope.prepareData();
            var urlsvc = 'service/client.svc/SaveCIF'; // 1
            var postData = { cifdata: $scope.CIFInvestor } // 2
            var preconfirmtranslate = "submitPhoto"; // 3
            var method = "POST" // 4
            $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {
                if (data) {
                    if (data.message == "savedatasuccess") {
                        if ($scope.broker.OAO) {
                            Swal.fire('success', 'Save Photo Berhasil', 'success').then(function () {
                                $window.location.href = "#/cif/data-pernyataan";
                            });
                        }
                        else {
                            Swal.fire('success', 'Save Photo Berhasil', 'success').then(function () {
                                $window.location.href = "#/cif/data-pernyataan";
                            });
                        }
                    }
                }
            });
        }

        $scope.submit = function () {
            if ($scope.CIFInvestor.TandaTanganFile) {
                $scope.CIFInvestor.IsFinished = 0;
                $scope.CIFInvestor.Stage = 4;
                console.log("ktpPhoto ", $scope.ktpPhoto);
                console.log("tabunganPhoto ", $scope.npwpPhoto);
                console.log("npwpPhoto ", $scope.tabunganPhoto);
                console.log("Selfie ", $scope.selfiePhoto);

                if (!$scope.broker.OAO) {
                    //$scope.CIFInvestor.KTPFile = $scope.fileKTP;
                    //$scope.CIFInvestor.SelfieFile = $scope.fileFotoDiri;
                    $scope.CIFInvestor.IsFinished = 1;

                    if ($scope.ktpPhoto)
                        $scope.CIFInvestor.KTPFile = $scope.ktpPhoto.replace("data:image/jpeg;base64,", "");

                    if ($scope.npwpPhoto)
                        $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

                    if ($scope.tabunganPhoto)
                        $scope.CIFInvestor.BukuTabunganFile = $scope.tabunganPhoto.replace("data:image/jpeg;base64,", "");

                    if ($scope.selfiePhoto)
                        $scope.CIFInvestor.SelfieFile = $scope.selfiePhoto.replace("data:image/jpeg;base64,", "");

                    console.log("KTPFile ", $scope.CIFInvestor.KTPFile);
                    console.log("SelfieFile ", $scope.CIFInvestor.SelfieFile);
                } else {

                    if ($scope.npwpPhoto)
                        $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/jpeg;base64,", "");

                    if ($scope.tabunganPhoto)
                        $scope.CIFInvestor.BukuTabunganFile = $scope.tabunganPhoto.replace("data:image/jpeg;base64,", "");
                }

                console.log("NPWP2 ", $scope.CIFInvestor.NPWPFile);
                console.log("TTD2 ", $scope.CIFInvestor.TandaTanganFile);

                $scope.prepareData();
                var urlsvc = 'service/client.svc/SaveCIF'; // 1
                var postData = { cifdata: $scope.CIFInvestor } // 2
                var preconfirmtranslate = "submitCif4"; // 3
                var method = "POST" // 4
                $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (data) {
                    if (data) {
                        if (data.message == "savedatasuccess") {
                            if ($scope.broker.OAO) {
                                Swal.fire('success', 'Dokumen Berhasil, Tahap Selanjutnya E-KYC Nasabah', 'success').then(function () {
                                    $window.location.href = "#/cif/final";
                                });
                            }
                            else {
                                Swal.fire('success', 'Permohonan pembukaan rekening efek Anda telah kami terima. Silahkan cek email', 'success').then(function () {
                                    $window.location.href = "#/dashboard";
                                });
                            }
                        }
                    }
                });
            }
        }

        $scope.logOff = function () {
            $http({
                method: 'POST',
                url: 'service/client.svc/logOff',
            }).then(function (data) {
                console.log(data);
                if (data.data.d == true) {
                    $window.location.href = "#/login";
                    $window.location.reload();
                }
            }, function (error) { })
        };

    }]);